/**
 * Peca vendida avulsa e a coluna da planilha que e a MESMA peca de producao.
 *
 * Na primeira venda de uma peca a API cria um item para ela no contrato
 * (observacao 'pecaAvulsa', nome "Luva do Encarte 4 cores - 22x30"). Quando o
 * contrato ja tem essa peca como produto ("Embalagem - Luva do Encarte 4
 * cores 22x30"), a venda soma na coluna dele. So junta com o mesmo nome e o
 * mesmo formato: formato desconhecido de um dos lados, qualquer diferenca no
 * nome ou mais de uma coluna candidata e duvida, e a peca fica na coluna dela.
 *
 * Copia da regra do portal (area_fomando/src/services/MesmaPeca.js): as
 * duas planilhas precisam juntar do mesmo jeito.
 */

export const OBSERVACAO_DA_PECA = 'pecaAvulsa';

/** "EMBALAGEM - " e "OUTROS - ": a categoria do plano, nao o nome da peca. */
const PREFIXO_DE_CATEGORIA = /^(embalagem|outros)\s*[-–—:]?\s*/;

/** Formato de impressao: dois digitos ou mais de cada lado (22x30, 30x44). */
const FORMATOS = /\b\d{2,}\s*x\s*\d{2,}\b/g;

function normalizar(texto) {
  return String(texto || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** O formato do texto, ou null se nao houver - ou se houver mais de um. */
function formatoDe(texto) {
  const achados = (normalizar(texto).match(FORMATOS) || []).map((formato) =>
    formato.replace(/\s+/g, '')
  );
  const unicos = achados.filter((formato, i) => achados.indexOf(formato) === i);

  return unicos.length === 1 ? unicos[0] : null;
}

/**
 * Identidade de producao: nome sem a categoria e sem pontuacao, mais o
 * formato. "Luva do Encarte 4 cores - 22x30" -> "luva do encarte 4 cores|22x30".
 * Sem formato conhecido, nao ha identidade (null).
 */
export function identidadeDaPeca(nome, descricao) {
  const formato = formatoDe(nome) || formatoDe(descricao);
  if (!formato) return null;

  const base = normalizar(nome)
    .replace(PREFIXO_DE_CATEGORIA, '')
    .replace(FORMATOS, ' ')
    .replace(/[-–—:]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  return base ? `${base}|${formato}` : null;
}

export function ehPecaVendida(item) {
  return Boolean(item) && item.observacao === OBSERVACAO_DA_PECA;
}

/**
 * Indice da coluna que e a mesma peca, ou -1. `colunas` sao { nome,
 * descricao } - a descricao so ajuda a achar o formato de um produto que
 * nao o traz no nome. Exige exatamente uma coluna com a mesma identidade.
 */
export function colunaDaMesmaPeca(peca, colunas) {
  const chave = identidadeDaPeca(peca && peca.produto, peca && peca.descricao);
  if (!chave) return -1;

  const iguais = [];
  (colunas || []).forEach((coluna, indice) => {
    if (identidadeDaPeca(coluna.nome, coluna.descricao) === chave) {
      iguais.push(indice);
    }
  });

  return iguais.length === 1 ? iguais[0] : -1;
}



// WEBPACK FOOTER //
// ./src/services/mesmaPeca.js